"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _header = _interopRequireDefault(require("@/layout/component/header.vue"));
var _main = _interopRequireDefault(require("@/layout/component/main.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'layoutTransverse',
  components: {
    Headers: _header.default,
    Mains: _main.default
  }
};